import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import { StringValidationRule } from "../../../../data/validation/rules"
import Validation from "../../../../data/validation/validation"

const getDefaultState = () => {
    return {
        creating: false,
        currency: "",
        amount: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.currency, (error) => errors.currency = error, { min: { value: 1, error: "Invalid" }, max: { value: 1, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.amount, (error) => errors.amount = error, { min: { value: 1, error: "Too short" }, max: { value: 5, error: "Too long" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const acceptManuscript = (instance) => {
    instance.setState({
        ...instance.state,
        creating: true,
        flag: {
            type: "",
            text: ""
        }
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/submission/admin/manuscript/accept",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            manuscriptId: instance.props.manuscriptId,
            Authorization: store.getState().auth.authorization
        }
    }).then(response => handleAcceptManuscriptResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                creating: false,
                flag: {
                    type: "error",
                    text: "Unknown error"
                }
            })
        })
}

const handleAcceptManuscriptResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.props.history.push('/manuscripts')
            break
        default:
            instance.setState({
                ...instance.state,
                creating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}


const Worker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        acceptManuscript: () => acceptManuscript(instance)
    }
}

export default Worker